var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { cx } from '@web/utility';
var supportedColors = [
    'green',
    'yellow',
    'red',
    'blue',
    'gray',
    'purple',
    'pink',
    'emerald',
    'sky'
];
var getClassByColor = function (color) {
    if (color && supportedColors.includes(color))
        return "bg-".concat(color, "-100 text-").concat(color, "-800");
    return '';
};
var Badge = function (_a) {
    var children = _a.children, color = _a.color, className = _a.className, customStyles = _a.customStyles;
    return (_jsx("span", __assign({ className: cx('px-2 inline-flex text-sm leading-5 font-semibold rounded-full py-0.5', getClassByColor(color), className, customStyles) }, { children: children })));
};
export default Badge;
